import router from './router'
import store from './store'
import utils from './utils/utils'
import secret from './utils/secret'
import { getToken, getUserToken } from '@/utils/cookies'
import { removeLocalOrderProsData } from '@/utils/storage'
import { GetUserInfo } from './store/modules/user'
// 不需要删除缓存的路由
const unWantedRemoveLocalData = {
  account: '/account'
}

// const prodEnv = process.env.NODE_ENV
const LIB_PLATFORM_PATH = process.env.LIB_PLATFORM_PATH
const JGSSO_WEB_URL = process.env.JGSSO_WEB_URL
const READ_PLATFORM_PATH = process.env.READ_PLATFORM_PATH



router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) {
    next()
  } else {
    const toPath = to.path // 跳转路由
    const toMeta = to.meta // 跳转路由信息
    let requireAuth = toMeta.requireAuth // 是否需要登录
    let jumpAuth = toMeta.jumpAuth // 是否个人中心跳转
    const isLogin = store.getters.isLogin
    const token = getUserToken() // 游客token
    const userToken = getUserToken() // 登录用户token
    let existToken = utils.isNotEmpty(token) // 存在游客token
    
    // 导航栏选中
    // navToolbarChecked(toPath)
    // ------------------ 处理重定向路径-start
    let targetUrl = JGSSO_WEB_URL + toPath
    // console.log('targetUrl',targetUrl)
    let existUserToken  ;
    let paramsRedirectUrl = 'redirectUrl=' + secret.encryptionText(LIB_PLATFORM_PATH + from.fullPath)
    let params = '?' + paramsRedirectUrl // 回调路径参数
    // console.log("paramsRedirectUrl",paramsRedirectUrl)
    let targetFullUrl = (isLogin && jumpAuth) ? targetUrl : targetUrl + params
    // console.log('targetFullUrl',targetFullUrl)
    // console.log("获取重定向地址", targetFullUrl,to)
    // ------------------ 处理重定向路径-end
    // ------------------ 处理登录数据信息 - start
    // console.log("jumpAuth=",jumpAuth)
    
    if (existToken) { // 存在游客token
      // console.log("targetFullUrl",targetFullUrl);
      store.dispatch('GetUserInfo').then(res => {
        let existUserToken =  res.data; // 存在登录用户token

        // console.log("需要登录");
        if (existUserToken) { // 存在登录token
          // console.log("存在登录token");
          if (jumpAuth) {
            // console.log("jumpAuth错误");
            window.location.href = targetFullUrl
          } else {
            // console.log("jumpAuth正确");
            store.dispatch('GetUserInfo').then(res => {
              next()
            }).catch(() => {
            })
          }
        } else { // 不存在登录token
          // console.log("不存在登录token");
          window.location.href = targetFullUrl
        }
      })
      




      if (requireAuth) {
        
        window.location.href = targetFullUrl
       
      } else {
        // console.log("不需要登录1");
        if (existUserToken) {
          // console.log("用户已登录2");
           // 存在登录token
        
          if (jumpAuth) {
            window.location.href = targetFullUrl
            // console.log("存在登录token");
          } else {
            store.dispatch('GetUserInfo').then(res => {
              next()
            }).catch(() => {
            })
          }
        } else { // 不存在登录token
          next()
        }
      }
    } else { // 获取游客token
      // console.log("获取游客token");
      store.dispatch('findToken').then(res => {
        next()
      })
    }
    // ------------------ 处理登录数据信息 - end
  }
})







router.beforeResolve((to, from, next) => {
  next()
})

/** 路由离开 */
router.afterEach((to, from) => {
  if (to.path !== unWantedRemoveLocalData.account) {
    removeLocalOrderProsData()
  }
})



// WEBPACK FOOTER //
// ./src/permission.js